import { ClassificationsValueDto } from "../../models/agency-types";

const byName = (a, b) => a.Name < b.Name ? -1 : 1;

const getAllowedClassifications = (type: ClassificationsValueDto, allClassifications, filter?: (i) => boolean) => {
	if(type === undefined) {
		const classifications = (allClassifications ?? []).some(c => c.Name.startsWith("License Type"))
		? allClassifications.filter(c => c.Name.startsWith("License Type"))
		: [...(allClassifications ?? [])];

		return classifications
			.sort(byName);
	}
	const classifications = (type.Items ?? [])
		.filter(c => filter?.(c) ?? true)
		.map(c => (allClassifications ?? []).find(ac => ac.Code === c.Item.Code))
		.sort(byName);

	return classifications;
};

export const getPrimaryClassificationsForType = (type: ClassificationsValueDto, allClassifications) => 
	getAllowedClassifications(type, allClassifications, c => c.IsPrimary);

export const getAttributeClassificationsForType = (type: ClassificationsValueDto, allClassifications) => 
	getAllowedClassifications(type, allClassifications, c => c.IsAttribute);